import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M22 2H2v15h6v5l4-2 4 2v-5h6V2zm-2 13H4v-2h16v2zm0-5H4V4h16v6z"
}), 'CardMembershipSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/CardMembershipSharp.js
// module id = 2686
// module chunks = 2